export default __webpack_public_path__ + "static/media/EM0550.34I-41828_-25089_0.1832bffa.jpg";